/**
 * Mutation to add a typology to a seller
 */
const addTypologyToSellerMutation = `
mutation AddTypologyToSeller($sellerId: ID!, $typologyId: ID!) {
  updateMarketplace_seller(
    input: {
      id: $sellerId
      fields: {
        typologies: {
          add: [$typologyId]
        }
      }
    }
  ) {
    marketplace_seller {
      objectId
      typologies {
        edges {
          node {
            objectId
            name
          }
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default addTypologyToSellerMutation;
